import { ErrorBox } from './Feedback';

export function DocumentLoadStatus({ loading, error, onRetry, retryAvailable = false, disabled = false }: { loading: boolean; error: string; onRetry: () => void; retryAvailable?: boolean; disabled?: boolean }) {
  if (loading) return <p role="status">Se încarcă lista documentelor și fotografiilor…</p>;
  if (!error && !retryAvailable) return null;
  return <div>{error && <ErrorBox message={error} />}<button type="button" className="btn btn-secondary" disabled={disabled} onClick={onRetry}>Reîncearcă citirea listei</button></div>;
}
